import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
], -1)
const _hoisted_4 = ["data-bs-target"]
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Full Name", -1)
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Company", -1)
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fw-bold fs-6" }
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, [
  /*#__PURE__*/_createTextVNode(" City "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Phone number must be active"
  })
], -1)
const _hoisted_16 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_17 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, [
  /*#__PURE__*/_createTextVNode(" Address "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Phone number must be active"
  })
], -1)
const _hoisted_20 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_21 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Date Joined ", -1)
const _hoisted_24 = { class: "col-lg-8" }
const _hoisted_25 = { class: "fw-bolder fs-6" }
const _hoisted_26 = { class: "row mb-10" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Role", -1)
const _hoisted_28 = { class: "col-lg-8" }
const _hoisted_29 = { class: "fw-bold fs-6" }
const _hoisted_30 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6" }
const _hoisted_31 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_32 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Notice", -1)
const _hoisted_35 = { class: "fs-6 text-gray-600" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Your last login date was ")
const _hoisted_37 = { class: "fw-bolder" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(". Keep it up! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_UpdateProfileModal = _resolveComponent("UpdateProfileModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-primary",
          "data-bs-toggle": "modal",
          "data-bs-target": `#${_ctx.$modals.PROFILE_MODAL}`
        }, " Edit Profile ", 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user?.fullname), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.user?.company_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.user?.city), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.user?.street_address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$filters.formatDate(_ctx.user?.date_joined)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.user?.user_type ? _ctx.userTypes[_ctx.user.user_type] : "User"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$filters.formatDate(_ctx.user?.last_login)), 1),
                _hoisted_38
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_UpdateProfileModal)
  ], 64))
}